import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import Icon from "./Icon";

export default function SettingsPage({ user, onBack, onImport, onSignOut }) {
  const [, setProfile] = useState({});
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          setProfile(snap.data());
          return;
        }
      } catch {}
      const local = localStorage.getItem(`gulliver_profile_${user.uid}`);
      if (local) {
        try { setProfile(JSON.parse(local)); } catch {}
      }
    };
    load();
  }, [user.uid]);

  const calendarUrl = `https://www.gullivertravels.app/api/calendar?userId=${user.uid}`;
  const webcalUrl = `webcal://www.gullivertravels.app/api/calendar?userId=${user.uid}`;
  const forwardEmail = "GulliverTravelsPlans@gmail.com";

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 28 }}>
      <div style={{
        fontSize: 11, fontWeight: 600, color: "var(--ink-light)",
        textTransform: "uppercase", letterSpacing: "0.08em",
        marginBottom: 12, paddingBottom: 6, borderBottom: "1px solid var(--border)",
      }}>
        {title}
      </div>
      {children}
    </div>
  );

  return (
    <>
      <header className="header">
        <button className="icon-btn" onClick={onBack}>
          <Icon name="back" size={18} />
        </button>
        <div className="header-logo" style={{ fontSize: 17 }}>Settings</div>
        <div style={{ width: 34 }} />
      </header>

      <main className="main" style={{ paddingBottom: 40 }}>

        <Section title="Account">
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "4px 0 12px" }}>
            {user.photoURL && (
              <img src={user.photoURL} alt="avatar" style={{ width: 44, height: 44, borderRadius: "50%" }} />
            )}
            <div>
              <div style={{ fontSize: 15, fontWeight: 500, color: "var(--ink)" }}>{user.displayName}</div>
              <div style={{ fontSize: 13, color: "var(--ink-light)" }}>{user.email}</div>
            </div>
          </div>
          <button
            onClick={onSignOut}
            style={{
              background: "none", border: "1px solid var(--border)", borderRadius: "var(--radius-sm)",
              padding: "8px 16px", fontFamily: "var(--font-body)", fontSize: 13,
              color: "var(--ink-mid)", cursor: "pointer", display: "flex", alignItems: "center", gap: 8,
            }}
          >
            <Icon name="signout" size={14} /> Sign out
          </button>
        </Section>

        <Section title="Add trips by email">
          <div style={{ fontSize: 13, color: "var(--ink-light)", marginBottom: 10, lineHeight: 1.5 }}>
            Forward any confirmation email and Claude will parse it and add it to the right trip automatically.
          </div>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            background: "var(--paper-warm)", border: "1px solid var(--border)",
            borderRadius: "var(--radius-sm)", padding: "10px 14px", marginBottom: 8,
          }}>
            <span style={{ fontSize: 13, fontWeight: 500, color: "var(--ink)" }}>{forwardEmail}</span>
            <button className="copy-btn" onClick={() => { navigator.clipboard?.writeText(forwardEmail); showToast("Copied!"); }}>Copy</button>
          </div>
        </Section>

        <Section title="Calendar feed">
          <div style={{ fontSize: 13, color: "var(--ink-light)", marginBottom: 10, lineHeight: 1.5 }}>
            Subscribe to get all your trips in any calendar app. Copy the URL and paste it into your calendar app to subscribe.
          </div>
          <div style={{
            background: "var(--paper-warm)", border: "1px solid var(--border)",
            borderRadius: "var(--radius-sm)", padding: "10px 14px", marginBottom: 10,
            fontSize: 12, color: "var(--ink-mid)", wordBreak: "break-all",
          }}>
            {calendarUrl}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <a href={webcalUrl} className="seg-btn primary" style={{ textDecoration: "none", fontSize: 13 }}>
              + Apple Calendar
            </a>
            <button className="seg-btn" onClick={() => { navigator.clipboard?.writeText(calendarUrl); showToast("Copied!"); }}>
              Copy URL
            </button>
          </div>
        </Section>

        <Section title="Import from TripIt">
          <div style={{ fontSize: 13, color: "var(--ink-light)", marginBottom: 10, lineHeight: 1.5 }}>
            Migrate your existing trips from TripIt into Gulliver.
          </div>
          <button className="seg-btn primary" onClick={() => onImport?.()}>
            📋 Open TripIt importer
          </button>
        </Section>

      </main>

      {toast && <div className="toast">{toast}</div>}
    </>
  );
}
